import React from 'react';

import { Dropdown, Menu } from 'antd';
import cx from 'classnames';
import Icon from '@ant-design/icons';

import { ReactComponent as ThreeDotsIcon } from '../../../../assets/sightx-icons/svg/icon-menu.svg';

import styles from './actionsMenu.module.scss';

interface ActionsMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
  editLabel?: string;
  deleteLabel?: string;
  disabled?: boolean;
}

const stopPropagationHandle = (e: React.MouseEvent<HTMLElement>) => e.stopPropagation();

const ActionsMenu: React.FC<ActionsMenuProps> = ({ onDelete, onEdit, deleteLabel, editLabel, disabled = false }) => {
  const onDeleteWithStopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    if(onDelete) {
      onDelete();
    }
  };
  const onEditWithStopPropagation = (e: React.MouseEvent<HTMLElement>) => {
    if(onEdit) {
      onEdit();
    }
  };
  const menu = (
    <Menu className={styles.menu}>
      {
        (typeof onEdit === 'function') && (
          <Menu.Item>
            <div className={styles.menuItemContent} onClick={onEditWithStopPropagation}>{editLabel ?? 'Edit'}</div>
          </Menu.Item>
        )
      }
      {
        (typeof onDelete === 'function') && (
          <Menu.Item>
            <div className={styles.menuItemContent} onClick={onDeleteWithStopPropagation}>{deleteLabel ?? 'Delete'}</div>
          </Menu.Item>
        )
      }
    </Menu>
  );

  return (
    <Dropdown className={styles.dropdown} trigger={['click']} overlay={menu} disabled={disabled} placement="bottomLeft">
      <Icon className={cx(styles.icon, { [styles.disabled]: disabled })} component={ThreeDotsIcon} onClick={stopPropagationHandle}/>
    </Dropdown>
  );
};

export { ActionsMenu };
